'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var Button = require('@material-ui/core/Button');
var SwipeableDrawer = require('@material-ui/core/SwipeableDrawer');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);
var SwipeableDrawer__default = /*#__PURE__*/_interopDefaultLegacy(SwipeableDrawer);

/**
 * Menu panel.
 */

var MobileMenuPanel = _ref => {
  var {
    isOpen,
    toggle,
    children
  } = _ref;
  return /*#__PURE__*/React__default['default'].createElement(SwipeableDrawer__default['default'], {
    anchor: "bottom",
    open: isOpen,
    onClose: () => toggle('false'),
    onOpen: () => toggle('true'),
    sx: {
      zIndex: 9999
    },
    disableSwipeToOpen: true,
    disableDiscovery: true,
    PaperProps: {
      sx: {
        top: 64,
        borderTopLeftRadius: '16px',
        borderTopRightRadius: '16px',
        paddingTop: 2,
        paddingBottom: "42px"
      }
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", null, children), /*#__PURE__*/React__default['default'].createElement(Button__default['default'], {
    onClick: () => toggle('false'),
    sx: {
      position: 'fixed',
      bottom: 2,
      right: 2
    }
  }, "Done"));
};
MobileMenuPanel.propTypes = {
  /** Content of the menu list. */
  children: index.node,
  isOpen: index.bool,
  toggle: index.func
};

exports.MobileMenuPanel = MobileMenuPanel;
